/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";

import { SharedStateStore } from "../store/SharedStateStore";

/**
 * Set the time-zone in the shared state store.
 * Time-zone is a string representing the IANA time-zone identifier.
 * @example setTimeZone("Europe/Dublin")
 */
export const setTimeZone = mutatorAction("setTimeZone", (timeZone: string) => {
    SharedStateStore().timeZone = timeZone;
});
